import { forwardRef } from 'react';
import MuiBox from '@mui/material/Box';
import type { BoxProps } from './IBox';
import { styles } from './styles';

const Box = forwardRef<HTMLDivElement, BoxProps>(
    ({ sx, ...rest }, ref) => (
        <MuiBox
            ref={ref}
            sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
            {...rest}
        />
    ),
);

Box.displayName = 'Box';

export default Box;
